import cn from 'clsx'

import css from './list.module.css'

import { Box, type BoxProps } from '@/components/Box/Box'

interface ListProps extends Omit<BoxProps, 'tag'> {
    tag?: 'ul' | 'ol'
}

export function List({ tag = 'ul', className, children, ...rest }: ListProps) {
    return (
        <Box tag={tag} className={cn(css[tag], className)} {...rest}>
            {children}
        </Box>
    )
}
